import { Component, OnInit } from '@angular/core';
import { ConfigLoaderService } from '../../Shared/Services/Config/config-loader.service';
import { HttpClientModule } from '@angular/common/http';

import { MDBModalRef, MDBModalService } from 'angular-bootstrap-md';
import { ModalComponent } from '../../Shared/Components/modal/modal.component';
import {AdminService} from '../../Shared/Services/Admin/admin.service';
import { Console, timeStamp } from 'node:console';
import {NotificationModal} from '../../Shared/Model/notification/notificationModal';

 declare var fullScroll :any;
 declare var PageScroll :any;
declare var $: any;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  modalRef!: MDBModalRef;

  ContentHeader!: string;
  ContentBody!: string;

  notificationMessage!:string;
  showalertMsg: boolean = false;
  alertMsg!:string;
  alertmsgClass!: string;

  notificationlist!:NotificationModal[];

 
 




  constructor(
    private _configLoaderService: ConfigLoaderService,
    private _http: HttpClientModule,
    private modalService: MDBModalService,
    private _adminService:AdminService) {

  }

  ngOnInit(): void {
 

    this.getTextValues();
   // this.btnStartClick();
   
    $("#main").PageScroll({
      selectors : {
        sections : ".sections",
        section : ".section",
        insection : ".insection",
        page : ".pages",
        active : ".active",
        controlPrev : ".control-prev",
        controlNext : ".control-next"
      },
      index : 0,	
      easing : "easeInOutExpo",
      duration : 500,
      loop : false,
      pagination : true,
      keyboard :true,
      direction : "vertical",
      callback : ""
    })

    this.getNotificaitonMessage();

  
  }

  getTextValues() {
    this.ContentHeader = "UNLEASH THE POWER OF INSIGHTS FOR YOUR SAP";
    this.ContentBody = "Accenture System Diagnostics (ASD) is an Accenture proprietary capability that offers technical diagnostic assessment solutions for various SAP systems.ASD offers insightful diagnostic reports that can provide deep technical insights into your SAP systems.";   
   
  }

  getNotificaitonMessage(){
  
    this._adminService.selectNotificationMessage( ConfigLoaderService.settings.AppSettings.userId)
    .subscribe((data:any)=>{    
      console.log( data)
       if(ConfigLoaderService.settings.AppSettings.showNotificationMessage){
        if(data!=undefined&&data!="null"&&data!=''){
       
       
          this.alertmsgClass = 'alert alert-success';
          this.alertMsg =  data;
          this.showalertMsg = true;  
          $("#success").toast("show");      
        }
      }
      

     })

  }





 




}
